import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { notification } from "antd";
import EmployeeService from "services/EmployeeService";
export const initialState = {
  data: [],
  dataDetail: [],
  dataAttendance: [],
  loading: false,
  error: null,
  redirect: false,
};

export const fetchEmployeeData = createAsyncThunk(
  "employee/fetchEmployeeData",
  async (data, { rejectWithValue }) => {
    try {
      const { page, pageSize, sort, searchText, role, state } = data;
      const response = await EmployeeService.get({
        page,
        pageSize,
        sort,
        searchText,
        role,
        state,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Error");
    }
  }
);

export const fetchEmployeeDetail = createAsyncThunk(
  "employee/fetchEmployeeDetail",
  async (id, { rejectWithValue }) => {
    try {
      const response = await EmployeeService.getById(id);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const fetchEmployeeAttendance = createAsyncThunk(
  "employee/fetchEmployeeAttendance",
  async (data, { rejectWithValue }) => {
    const { id, page, pageSize } = data;
    try {
      const response = await EmployeeService.getAttendance({
        id,
        page,
        pageSize,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const createEmployeeData = createAsyncThunk(
  "employee/createEmployeeData",
  async (data, { rejectWithValue }) => {
    try {
      const {
        first_name,
        middle_name,
        last_name,
        email,
        phone_nr,
        id_nr,
        password,
        outlet,
        districts,
        role,
      } = data;
      const response = await EmployeeService.createEmployee({
        first_name,
        middle_name,
        last_name,
        email,
        phone_nr,
        id_nr,
        password,
        outlet,
        districts,
        role,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const updateEmployeeData = createAsyncThunk(
  "employee/updateEmployeeData",
  async (data, { rejectWithValue }) => {
    try {
      const {
        id,
        first_name,
        middle_name,
        last_name,
        email,
        phone_nr,
        id_nr,
        password,
        outlet,
        districts,
        role,
      } = data;
      const response = await EmployeeService.updateEmployee({
        id,
        first_name,
        middle_name,
        last_name,
        email,
        phone_nr,
        id_nr,
        password,
        outlet,
        districts,
        role,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const deleteEmployeeData = createAsyncThunk(
  "employee/deleteEmployeeData",
  async (id, { rejectWithValue }) => {
    try {
      const response = await EmployeeService.deleteEmployee(id);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const employeeSlice = createSlice({
  name: "employee",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmployeeData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchEmployeeData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
      })
      .addCase(fetchEmployeeData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchEmployeeDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchEmployeeDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.dataDetail = action.payload.data;
        state.error = null;
      })
      .addCase(fetchEmployeeDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchEmployeeAttendance.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchEmployeeAttendance.fulfilled, (state, action) => {
        state.loading = false;
        state.dataAttendance = action.payload.data;
        state.error = null;
      })
      .addCase(fetchEmployeeAttendance.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createEmployeeData.pending, (state) => {
        state.loading = true;
        state.redirect = false;
      })
      .addCase(createEmployeeData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.redirect = true;
        notification.success({ message: "Proses Berhasil" });
      })
      .addCase(createEmployeeData.rejected, (state, action) => {
        state.redirect = false;
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateEmployeeData.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateEmployeeData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.redirect = true;
        notification.success({ message: "Proses Berhasil" });
      })
      .addCase(updateEmployeeData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteEmployeeData.pending, (state) => {
        state.redirect = false;
        state.loading = true;
      })
      .addCase(deleteEmployeeData.fulfilled, (state) => {
        state.loading = false;
        state.redirect = true;
        notification.success({ message: "Proses Berhasil" });
      })
      .addCase(deleteEmployeeData.rejected, (state, action) => {
        state.redirect = false;
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { showLoading } = employeeSlice.actions;

export default employeeSlice.reducer;
